import { VolumeIndicatorFill } from "../../../../../ui/volume-indicator/fill.js";
import { VolumeIndicatorRoot } from "../../../../../ui/volume-indicator/root.js";
import { VolumeIndicatorValue } from "../../../../../ui/volume-indicator/value.js";
import ForwardRef from "../../../../../icons/dist/react/minimal/volume-high.js";
import ForwardRef$1 from "../../../../../icons/dist/react/minimal/volume-low.js";
import ForwardRef$2 from "../../../../../icons/dist/react/minimal/volume-off.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn, resolveClassName } from "@videojs/utils/style";
//#region src/internal/skins/minimal-video/components/feedback/volume-indicator.tsx
/** @jsxImportSource react */
function VolumeIndicator({ className, ...props } = {}) {
	return /* @__PURE__ */ jsx(VolumeIndicatorRoot, {
		className: (state) => cn("media-indicator", "media-volume-indicator", resolveClassName(className, state)),
		...props,
		children: /* @__PURE__ */ jsxs(VolumeIndicatorFill, {
			className: cn("media-indicator-content", "media-volume-indicator-fill"),
			children: [
				/* @__PURE__ */ jsx(ForwardRef, { className: "media-volume-indicator-high-icon" }),
				/* @__PURE__ */ jsx(ForwardRef$1, { className: "media-volume-indicator-low-icon" }),
				/* @__PURE__ */ jsx(ForwardRef$2, { className: "media-volume-indicator-off-icon" }),
				/* @__PURE__ */ jsx(VolumeIndicatorValue, { className: "media-volume-indicator-value" })
			]
		})
	});
}
//#endregion
export { VolumeIndicator };

//# sourceMappingURL=volume-indicator.js.map